




























import { Component, Vue } from "vue-property-decorator";
import { Getter } from 'vuex-class';
import LangPicker from "@/components/misc/LangPicker.vue";

@Component({
  components: {
    LangPicker
  }
})
export default class AuthLayout extends Vue {
  @Getter("isDarkTheme") isDarkTheme?: boolean;
  
  get title() {
    return this.$route.meta?.title ?? this.$route.name;
  }

  get isSignin() {
    return this.$route.meta?.title === "SigninTo";
  }

  mounted() {
    this.$vuetify.theme.dark = false;
  }

  destroyed() {
    this.$vuetify.theme.dark = this.isDarkTheme || false;
  }
}
